import styled from 'styled-components';
import { colors } from '../colors';

interface tableButtonContent {
	special?: boolean;
	noAction?: boolean;
	onHover?: boolean;
}

const TableButton = styled.button<tableButtonContent>`
	border: 0px;
	background: transparent !important;
	padding: 0px!important;
	width: auto !important;
	height: auto !important;
	transition: none!important;
	+ button{
		margin-left:20px!important;
	}
	span {
		color: ${colors.Grey58};
		font-size: 16px;
	}
	&:hover,
	&:active,
	&:focus {
		border:none!important;
		padding: 0px!important;
		span {
			color: ${colors.Red};
			&.icon-editIcon {
				&::before {
					color: ${colors.GreenBase};  
				}
			}
			&.icon-delete {
			 	&::before {
			 		color: ${colors.Red};
			 	}
			 }
		}
	}
	${({ special }) => special && `span{color: ${colors.GreyA2}}`}
	${({ noAction }) =>
		noAction &&
		`pointer-events: none;
	span{
		pointer-events: none;
	}`}
    ${({ onHover }) => onHover && `display: inline-block !important; margin-left: 5px;`}
`;

export default TableButton;
